import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function PaymentReturnHandler() {
  const { fetchUsage } = useAuth();
  const [polling, setPolling] = useState(false);
  const [result, setResult] = useState(null);

  const pollStatus = useCallback(async (sid, attempt) => {
    if (attempt >= 8) {
      setPolling(false);
      setResult("failed");
      return;
    }
    try {
      const { data } = await axios.get(`${API}/payments/status/${sid}`);
      if (data.payment_status === "paid") {
        setPolling(false);
        setResult("success");
        fetchUsage();
        setTimeout(() => window.location.reload(), 1500);
        return;
      }
      if (data.status === "expired") {
        setPolling(false);
        setResult("failed");
        return;
      }
      setTimeout(() => pollStatus(sid, attempt + 1), 2000);
    } catch {
      setTimeout(() => pollStatus(sid, attempt + 1), 2000);
    }
  }, [fetchUsage]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    const paymentStatus = params.get("payment");

    if (sid && paymentStatus === "success") {
      window.history.replaceState({}, "", window.location.pathname);
      setPolling(true);
      pollStatus(sid, 0);
    } else if (paymentStatus === "cancelled") {
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [pollStatus]);

  if (polling) {
    return (
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="payment-polling-overlay">
        <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-neutral-950 border border-neutral-800 p-8 max-w-md w-full text-center">
          <div className="animate-spin w-10 h-10 border-2 border-white border-t-transparent rounded-full mx-auto mb-4" />
          <h2 className="text-xl font-bold mb-2">Processing Payment...</h2>
          <p className="text-sm text-neutral-400">Verifying your upgrade. Please wait.</p>
        </motion.div>
      </div>
    );
  }

  if (result === "success") {
    return (
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="payment-success-overlay">
        <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-neutral-950 border border-green-800 p-8 max-w-md w-full text-center">
          <CheckCircle size={48} weight="fill" className="text-green-500 mx-auto mb-4" />
          <h2 className="text-xl font-bold mb-2 text-green-400">Welcome to Pro!</h2>
          <p className="text-sm text-neutral-400">Your limits have been upgraded 10x. Refreshing...</p>
        </motion.div>
      </div>
    );
  }

  return null;
}
